import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutionsSection } from '../components/FailedSolutionsSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludesSection } from '../components/IncludesSection';
import { ForWhomSection } from '../components/ForWhomSection';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { MetaPixel } from '../components/MetaPixel';
export function LandingPage() {
  return <>
      <MetaPixel data-id="element-137" />
      <main className="w-full min-h-screen bg-white" data-id="element-138">
        <Hero data-id="element-139" />
        <ProblemSection data-id="element-140" />
        <FailedSolutionsSection data-id="element-141" />
        <SolutionSection data-id="element-142" />
        <IncludesSection data-id="element-143" />
        <ForWhomSection data-id="element-144" />
        <PricingSection data-id="element-145" />
        <FinalCTA data-id="element-146" />
      </main>
      <Footer data-id="element-147" />
    </>;
}